import React from 'react';

const Home = () => (
  <div>
    {/* Hero Section */}
    <section style={{ padding: '80px 0 60px', textAlign: 'center' }}>
      <div className="container">
        <div style={{ width: 80, height: 80, background: 'linear-gradient(135deg, #D4A843, #BF8C2C)', borderRadius: 22, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, marginBottom: 24, boxShadow: '0 8px 24px rgba(212,168,67,0.3)' }}>🍿</div>
        <h1 style={{ fontSize: 42, fontWeight: 800, color: '#2D1A00', marginBottom: 12, lineHeight: 1.2 }}>Premium Chakna &<br />Snacks Delivered Fast</h1>
        <p style={{ fontSize: 16, color: '#6B6B6B', maxWidth: 500, margin: '0 auto 32px' }}>Your perfect party companion. Order the best chakna, namkeen, and snacks for your drinks — delivered to your nearest pickup point in minutes.</p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="#download" style={{ background: 'linear-gradient(135deg, #D4A843, #BF8C2C)', color: '#fff', padding: '14px 32px', borderRadius: 12, fontWeight: 600, fontSize: 15, textDecoration: 'none', boxShadow: '0 4px 12px rgba(212,168,67,0.3)' }}>Download App</a>
          <a href="#features" style={{ background: '#fff', color: '#2D1A00', padding: '14px 32px', borderRadius: 12, fontWeight: 600, fontSize: 15, textDecoration: 'none', border: '1px solid #E0D0B8' }}>Learn More</a>
        </div>
      </div>
    </section>

    {/* Features */}
    <section id="features" style={{ padding: '60px 0', background: '#fff' }}>
      <div className="container">
        <h2 style={{ fontSize: 28, fontWeight: 700, textAlign: 'center', marginBottom: 40, color: '#2D1A00' }}>Why Chakna Point?</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 24 }}>
          {[
            { emoji: '⚡', title: 'Ready in 10 Minutes', desc: 'Pick up your order from the nearest point in just 10 minutes.' },
            { emoji: '🍿', title: 'Premium Quality', desc: 'Curated selection of the best chakna, namkeen, and party snacks.' },
            { emoji: '🎉', title: 'Party Combos', desc: 'Pre-made combo packs perfect for every drink and occasion.' },
            { emoji: '💰', title: 'Best Prices', desc: 'Affordable prices with regular deals and combo offers.' },
            { emoji: '📍', title: 'Multiple Pickup Points', desc: 'Convenient pickup locations near you. No delivery wait.' },
            { emoji: '🔒', title: 'Secure Payments', desc: 'Safe and secure payment options including UPI, cards, and COD.' },
          ].map((f, i) => (
            <div key={i} style={{ background: '#F5E6C8', borderRadius: 14, padding: 24, textAlign: 'center' }}>
              <div style={{ fontSize: 32, marginBottom: 12 }}>{f.emoji}</div>
              <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#2D1A00' }}>{f.title}</h3>
              <p style={{ fontSize: 13, color: '#6B6B6B' }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Download CTA */}
    <section id="download" style={{ padding: '60px 0', textAlign: 'center' }}>
      <div className="container">
        <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 12, color: '#2D1A00' }}>Get the App Now</h2>
        <p style={{ fontSize: 14, color: '#6B6B6B', marginBottom: 24 }}>Available on Android. iOS coming soon.</p>
        <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', background: '#2D1A00', color: '#fff', padding: '14px 32px', borderRadius: 12, fontWeight: 600, fontSize: 15, textDecoration: 'none' }}>
          ▶ Get it on Google Play
        </a>
      </div>
    </section>
  </div>
);

export default Home;
